/** Vessel / cargo scope helpers for Operations UI filtering (backend remains authoritative). */

export type ScopedVesselLike = {
  id?: number
  companyGroupAdmin?: { id?: number } | null
  companyGroupAdminId?: number | null
  companyGroupId?: number | null
  companyAdmin?: { id?: number } | null
  companyAdminId?: number | null
  companyId?: number | null
}

export type ScopedCargoLike = {
  companyId?: number | null
  companyGroupAdminId?: number | null
  vesselId?: number | null
  vessel?: ScopedVesselLike | null
}

export function resolveVesselCompanyGroupId(vessel: ScopedVesselLike | null | undefined): number | null {
  if (!vessel) return null
  const n = Number(
    vessel.companyGroupAdmin?.id ?? vessel.companyGroupAdminId ?? vessel.companyGroupId ?? NaN
  )
  return Number.isFinite(n) && n > 0 ? n : null
}

export function vesselMatchesCompanyGroup(
  vessel: ScopedVesselLike,
  companyGroupId: number | null | undefined
): boolean {
  if (companyGroupId == null) return true
  const vid = resolveVesselCompanyGroupId(vessel)
  return vid != null && vid === Number(companyGroupId)
}

/** Keep backend-scoped cargo rows when cargo.companyId is null but vessel ownership matches. */
export function cargoRowVisibleInScope(
  row: ScopedCargoLike,
  companyGroupId: number | null | undefined
): boolean {
  if (companyGroupId == null) return true
  const rowCga = row.companyGroupAdminId ?? resolveVesselCompanyGroupId(row.vessel ?? undefined)
  if (rowCga != null && rowCga === Number(companyGroupId)) return true
  if (row.companyId != null && row.companyId === Number(companyGroupId)) return true
  return resolveVesselCompanyGroupId(row.vessel ?? undefined) === Number(companyGroupId)
}
